var TorsoView = require('backbone-torso/modules/View');
var PortalPerspectiveLayoutBehavior = require('./../PortalPerspectiveLayoutBehavior');
var AsideBehavior = require('./../aside/AsideBehavior');
var eregAppTemplate = require('./eregAppTemplate.hbs');

/**
 * Wrapper Perspective to display the E-reg app
 *
 * @class EregAppPerspective
 * @constructor
 */
module.exports = TorsoView.extend({
  className: 'app',
  template: eregAppTemplate,
  moduleNamespace: 'eregApp',

  behaviors: {
    portalPerspectiveLayoutBehavior: {
      behavior: PortalPerspectiveLayoutBehavior
    },
    asideBehavior: {
      behavior: AsideBehavior,
      asideHeaderMessageKey: function() {
        return this.view.contentView.get('asideHeaderMessageKey');
      },
      asideContentMessageKey: function() {
        return this.view.contentView.get('asideContentMessageKey');
      }
    }
  },

  /**
   * @method attachTrackedViews
   * @override
   */
  attachTrackedViews: function() {
    this.attachView('content', this.contentView);
  },

  setContentView: function(contentView) {
    if (this.contentView) {
      this.stopListening(this.contentView.viewState);
    }

    this.contentView = contentView;

    var asideBehavior = this.getBehavior('asideBehavior');
    this.listenTo(this.contentView.viewState, 'change:asideHeaderMessageKey change:asideContentMessageKey change:asideText', asideBehavior.updateAsideContent);
    asideBehavior.updateAsideContent();

    this.listenTo(this.contentView.viewState, 'change:navView', this.updateNavView);
    this.updateNavView();

    this.render();
  },

  /**
   * Update the nav view to the one used by the content view.
   * @method updateNavView
   */
  updateNavView: function() {
    this._stopListeningToHome();
    var navViewKey = this.contentView.get('navView');
    this.getBehavior('portalPerspectiveLayoutBehavior').setNavViewKey(navViewKey);
    this._listenToHome();
  },

  /**
   * Listen to the home event on the current navView, pass it along to the current contentView.
   * @private
   */
  _listenToHome: function() {
    var thisView = this;
    this.listenTo(this.getNavView(), 'home', function(payload) {
      // retrigger 'home' event on child
      thisView.contentView.trigger('home', payload.domEvent);
    });
  },

  /**
   * Stop listening to the home event on the current navView.
   * @private
   */
  _stopListeningToHome: function() {
    this.stopListening(this.getNavView(), 'home');
  },

  /**
   * @method _attached
   * @override
   * @private
   */
  _attached: function() {
    this._listenToHome();
  },

  /**
   * @method _detached
   * @override
   * @private
   */
  _detached: function() {
    this._stopListeningToHome();
  }
});
